var map = {
	"./angpao.webp": 2344,
	"./bonus.webp": 2345,
	"./gpi-rebate-m.webp": 2346,
	"./gpi-rebate.webp": 2347,
	"./hublot-watch-2018.webp": 2348,
	"./hublot-watch-2022.webp": 2349,
	"./iphone-13-pro-max.webp": 2350,
	"./iphone-14-pro-max.webp": 2351,
	"./login-to-m.webp": 2352,
	"./login-to.webp": 2353,
	"./mb.webp": 2354,
	"./mg-rebate-m.webp": 2355,
	"./mg-rebate.webp": 2356,
	"./np.webp": 2357,
	"./pointer.webp": 2358,
	"./pp-rebate-m.webp": 2359,
	"./pp-rebate.webp": 2360,
	"./sadface.webp": 2361,
	"./wallet-m.webp": 2362,
	"./wallet.webp": 2363,
	"./wheel-b.webp": 2364,
	"./wheel-btn.webp": 2365,
	"./wheel-indon-b.webp": 2366,
	"./wheel-indon.webp": 2367,
	"./wheel.webp": 2368
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 940;